module.exports = __webpack_public_path__ + "static/media/shape1_6.0fb1e65a.obj";